import React, { useState, useEffect } from "react";
import { IoClose } from "react-icons/io5";

export default function UpdateCounsellorPopup({
    title, // Title of the popup
    isOpen, // Boolean to control popup visibility
    onClose, // Function to close the popup
    fetchCounsellors, // Function to refresh the counsellor list
    updateCounsellor, // Function to update a counsellor
    data, // Counsellor data being edited
}) {
    const [counsellorDetails, setCounsellorDetails] = useState({
        id: "",
        name: "",
        designation: "",
        tele: "",
        email: "",
    });

    useEffect(() => {
        if (data) {
            setCounsellorDetails({
                id: data.id || "",
                name: data.name || "",
                designation: data.designation || "",
                tele: data.tele || "",
                email: data.email || "",
            });
        } else {
            setCounsellorDetails({ id: "", name: "", designation: "", tele: "", email: "" });
        }
    }, [data]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setCounsellorDetails((prevDetails) => ({
            ...prevDetails,
            [name]: value,
        }));
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        if (!counsellorDetails.name.trim() || !counsellorDetails.designation.trim() || !counsellorDetails.tele.trim() || !counsellorDetails.email.trim()) {
            alert("Please fill in all fields.");
            return;
        }

        try {
            await updateCounsellor(counsellorDetails.id, counsellorDetails);
            alert("Counsellor updated successfully!");
            onClose();
            fetchCounsellors();
        } catch (error) {
            console.error("Error updating counsellor:", error);
            alert("Failed to update counsellor. Please try again.");
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed top-0 left-0 z-50 flex items-center justify-center w-full h-full bg-black bg-opacity-50">
            <div className="w-[500px] p-6 bg-white rounded-lg shadow-lg relative">
                <div className="flex items-center justify-between mb-4">
                    <h2 className="text-xl font-semibold text-gray-700">{title}</h2>
                    <button
                        type="button"
                        className="text-gray-500 border rounded-md shadow-md hover:text-gray-700"
                        onClick={onClose}
                    >
                        <IoClose className="w-6 h-6" />
                    </button>
                </div>

                <form onSubmit={handleFormSubmit}>
                    <div className="mb-4">
                        <label className="block mb-1 text-sm font-medium text-gray-600" htmlFor="name">
                            Name
                        </label>
                        <input
                            id="name"
                            type="text"
                            name="name"
                            value={counsellorDetails.name}
                            onChange={handleInputChange}
                            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
                        />
                    </div>
                    <div className="mb-4">
                        <label className="block mb-1 text-sm font-medium text-gray-600" htmlFor="designation">
                            Designation
                        </label>
                        <input
                            id="designation"
                            type="text"
                            name="designation"
                            value={counsellorDetails.designation}
                            onChange={handleInputChange}
                            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
                        />
                    </div>
                    <div className="mb-4">
                        <label className="block mb-1 text-sm font-medium text-gray-600" htmlFor="tele">
                            Phone Number
                        </label>
                        <input
                            id="tele"
                            type="text"
                            name="tele"
                            value={counsellorDetails.tele}
                            onChange={handleInputChange}
                            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
                        />
                    </div>
                    <div className="mb-4">
                        <label className="block mb-1 text-sm font-medium text-gray-600" htmlFor="email">
                            Email
                        </label>
                        <input
                            id="email"
                            type="email"
                            name="email"
                            value={counsellorDetails.email}
                            onChange={handleInputChange}
                            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
                        />
                    </div>

                    <div className="flex justify-end gap-4">
                        <button
                            type="button"
                            className="px-6 py-2 text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300"
                            onClick={onClose}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="px-6 py-2 text-white bg-[#92288C] rounded-md hover:bg-[#6C0B67]"
                        >
                            Update
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}